import { defineMessages } from 'react-intl';

const messages = defineMessages({
  undoMarkShipped: {
    description: 'shipmentDetailsOtherActions.undoMarkShipped',
    defaultMessage: 'Undo "Mark as Shipped"',
    id: 'lomdW2',
  },
});

export const UndoMarkShipped = {
  translation: messages.undoMarkShipped,

  handler: ({ actions }) => {
    const { undoMarkShipped } = actions;
    undoMarkShipped();
  },

  shouldBeShown: ({ markedComplete }) => {
    return !!markedComplete;
  },
};
